export default __webpack_public_path__ + "static/media/MORGAN STANLEY HUB.91e1e201.jpg";